import uniq from 'lodash/uniq';

import {MetricType} from 'common/query-builder/query-block/constants';
import {SPECIAL_EVENTS} from 'common/report/constants';
import {renameEvent} from 'common/report/util/events';
import {MetricEntry} from 'common/query-builder/query-entry-section/types';

import {hasGroupByCohort, hasGroupByUser, isBehaviorShowClause} from '../models/utils';
import {InsightsBookmarkParams} from './types';

export function getRetentionAttributionItems(bookmarkParams: InsightsBookmarkParams) {
  const {show: showClauses, group} = bookmarkParams.sections;
  if (
    showClauses.length === 1 &&
    isBehaviorShowClause(showClauses[0]) &&
    [MetricType.Retention].includes(showClauses[0].behavior.type) &&
    group.length > 0 &&
    !hasGroupByCohort(group) &&
    !hasGroupByUser(group)
  ) {
    const {behaviors} = showClauses[0].behavior;
    const {retentionSegmentationEvent} = showClauses[0].measurement;
    const events = uniq([
      behaviors?.[0]?.name || SPECIAL_EVENTS.ANY_EVENT,
      behaviors?.[1]?.name || SPECIAL_EVENTS.ANY_EVENT,
    ]);
    return getAttributionItems(events, retentionSegmentationEvent, false);
  }
  return null;
}

export function getRetentionMetricAttributionItems(entry: MetricEntry) {
  // entries of type MetricType.RetentionFrequency do not need an attribution
  // selection choice since there's only one event
  if (entry.behavior.type !== MetricType.Retention) {
    return [];
  }
  const {
    behavior: {behaviors},
    measurement,
  } = entry;
  const events = uniq([
    behaviors?.[0]?.name || SPECIAL_EVENTS.ANY_EVENT,
    behaviors?.[1]?.name || SPECIAL_EVENTS.ANY_EVENT,
  ]);
  return getAttributionItems(events, measurement.attributionSelection, true);
}

function getAttributionItems(events: string[], attributionSelection: string | number, showStepNumbers: boolean) {
  return events.map((event, index) => ({
    value: event,
    index: String(index),
    label: showStepNumbers ? `Step ${index + 1}` : renameEvent(event),
    isSelected: event === attributionSelection,
  }));
}
